import React from 'react';
import {connect} from 'react-redux';
import AudioPlayer from '../../components/AudioPlayer';
import * as deNormingTest from './languages/de-test-data.js';

import strings from '../../utils/strings';
import Countdown from '../../components/Countdown/index.js';
import {updateObject} from '../../utils/reducerUtils';

const maxAudioPlayCount = 1;

const tutorialObj = {de: deNormingTest};
let count = 1;

class Test extends React.Component {
	constructor() {
		super();

		this.tutorial = tutorialObj[strings.getLanguage()];

		this.state = {
			counter: 1,
			selectedChoice: {},
			multiSelectedChoice: {},
			results: [],
			showTestPanel: true,
			nextQuestion: false,
			timeOut: false,
			showChoices: false,
			audioPlayCounts: {},
			imageLoaded: {}, // tracks which choice images have finished loading
		};

		// Assignments organized by counter
		this.singlePickAssignment = {
			1: this.tutorial.assignment1,
			2: this.tutorial.assignment2,
			3: this.tutorial.assignment3,
			4: this.tutorial.assignment4,
			5: this.tutorial.assignment5,
			6: this.tutorial.assignment6,
			7: this.tutorial.assignment7,
			8: this.tutorial.assignment8,
			9: this.tutorial.assignment9,
			10: this.tutorial.assignment10,
			11: this.tutorial.assignment11,
			12: this.tutorial.assignment12,
			13: this.tutorial.assignment13,
			14: this.tutorial.assignment14,
			15: this.tutorial.assignment15,
			16: this.tutorial.assignment16,
			17: this.tutorial.assignment17,
			18: this.tutorial.assignment18,
		};
		// Assignments organized by counter
		this.multiplePickAssignment = {
			19: this.tutorial.assignment19,
			20: this.tutorial.assignment20,
			21: this.tutorial.assignment21,
		};

		this.audioRefs = {};
	}

	handleSelect = (assignmentId, choiceIndex, choice) => {
		this.toggleTimeout('userAction');

		this.setState((prev) => ({
			selectedChoice: {
				...prev.selectedChoice,
				[assignmentId]: choiceIndex,
			},
			results: [
				...prev.results,
				{
					id: assignmentId,
					value: {
						isCorrect: choice.remarks === 'true',
						answerArray: [choice.word],
						isAnswered: true,
					},
				},
			],
			counter: count,
		}));
	};
	updateCount(prevousCount) {
		let emptyAnswer = [''];
		if (count > 19) {
			const {selectedWords} = this.getSelectionData(prevousCount);
			emptyAnswer = selectedWords;
		}

		this.setState({
			counter: count,
			timeOut: false,
			nextQuestion: true,
			showTestPanel: false,
			results: [
				...this.state.results,
				{
					id: prevousCount,
					value: {
						isCorrect: false,
						answerArray: emptyAnswer,
						isAnswered: false,
					},
				},
			],
		});
	}
	toggleTimeout(origin) {
		if (origin === 'audioAction') {
			this.setState({
				timeOut: true,
			});
		}

		if (origin === 'userAction') {
			this.setState({
				timeOut: false,
			});
		}
	}

	getSelectionData = (assignmentId) => {
		const selectedIndices =
			this.state.multiSelectedChoice[assignmentId] || [];
		const assignment = this.multiplePickAssignment[assignmentId][0];

		const selectedWords = selectedIndices.map(
			(idx) => assignment.choices[idx].word
		);

		const allSelected =
			selectedIndices.length === assignment.correctOrder.length;

		return {assignment, selectedWords, allSelected};
	};
	handleMultiSelect = (assignmentId, choiceIndex) => {
		this.setState(
			(prev) => {
				const selectedIndices =
					prev.multiSelectedChoice[assignmentId] || [];
				const maxSelections = assignmentId === 19 ? 3 : 4;
				let updatedIndices;

				if (selectedIndices.includes(choiceIndex)) {
					updatedIndices = selectedIndices.filter(
						(i) => i !== choiceIndex
					);
				} else if (selectedIndices.length < maxSelections) {
					updatedIndices = [...selectedIndices, choiceIndex];
				}

				return {
					multiSelectedChoice: {
						...prev.multiSelectedChoice,
						[assignmentId]: updatedIndices,
					},
				};
			},
			() => {
				const {assignment, selectedWords, allSelected} =
					this.getSelectionData(assignmentId);

				if (allSelected) {
					this.toggleTimeout('userAction');
					count = count + 1;

					const isCorrectOrder = selectedWords.every(
						(word, i) => word === assignment.correctOrder[i]
					);

					this.setState((prev) => ({
						showChoices: false, //make false
						results: [
							...prev.results,
							{
								id: assignmentId,
								value: {
									isCorrect: isCorrectOrder === true,
									answerArray: selectedWords,
									isAnswered: true,
								},
							},
						],

						counter: count,
					}));
				}
			}
		);
	};

	render() {
		const {onNextStep, isSendingTestResults} = this.props;
		const {
			results,
			showTestPanel,
			nextQuestion,
			selectedChoice,
			multiSelectedChoice,
			counter,
			timeOut,
			audioPlayCounts,
			showChoices,
		} = this.state;
		const isDoneButtonVisible = count === 19;

		return (
			<div className="lit-test">
				{timeOut && (
					<div className="lit-infobar">
						<Countdown
							duration={15}
							onComplete={() => {
								const prevCount = count;
								count = count + 1;
								this.updateCount(prevCount);
							}}
						/>
					</div>
				)}
				{showTestPanel && count < 19 && (
					<div className="lit-sprakforstaelse lit-sprakforstaelse__tutorial">
						{this.singlePickAssignment[counter].map(
							(assignment) => {
								const {id, choices} = assignment;
								const assignmentAudioPlayCount =
									audioPlayCounts[id] || 0;
								const isAudioDisabled =
									assignmentAudioPlayCount ===
									maxAudioPlayCount;

								return (
									<div className="lit-words-wrapper" key={id}>
										<div className="lit-single-word">
											<p className="instruction">
												<AudioPlayer
													inline
													disabled={isAudioDisabled}
													autoplay
													refs={this.audioRefs}
													src={assignment.mainSound}
													onComplete={() => {
														this.toggleTimeout(
															'audioAction'
														);
														this.setState({
															showChoices: true,
														});
													}}
													onPause={() => {
														this.toggleTimeout(
															'audioAction'
														);
													}}
													onStart={() => {
														this.setState({
															audioPlayCounts:
																updateObject(
																	audioPlayCounts,
																	{
																		[id]:
																			assignmentAudioPlayCount +
																			1,
																	}
																),
														});
													}}
												/>
												<span
													className="tutorial-step-badge"
													aria-label={`Trinn ${count} av 2`}
												>
													<span className="current">
														{id}
													</span>
													<span className="sep">
														von
													</span>
													<span className="total">
														18
													</span>
												</span>
											</p>
										</div>
										{/* Choices — always in DOM so images download during audio playback */}
										<div className={`lit-words${showChoices ? '' : ' lit-words--preloading'}`}>
											<div className="lit-word-list">
												{choices.map(
													(choice, i) => {
														const selected =
															selectedChoice[
																id
															] === i;
														const imgKey = `${id}-${i}`;
														const isLoaded = this.state.imageLoaded[imgKey];

														return (
															<span
																className={`lit-word ${
																	selected
																		? 'selected'
																		: ''
																}`}
																key={i}
																onClick={() => {
																	count =
																		count +
																		1;
																	this.setState(
																		{
																			showChoices: false,
																		}
																	);
																	this.handleSelect(
																		id,
																		i,
																		choice
																	);
																}}
															>
																<span className="sf-img-frame">
																	{showChoices && !isLoaded && (
																		<span className="img-skeleton" aria-hidden="true" />
																	)}
																	<img
																		className={`imgItem ${
																			selected
																				? 'selected'
																				: ''
																		}${showChoices && !isLoaded ? ' img-pending' : ''}`}
																		src={choice.img}
																		alt={choice.word}
																		loading="eager"
																		onLoad={() =>
																			this.setState((prev) => ({
																				imageLoaded: {
																					...prev.imageLoaded,
																					[imgKey]: true,
																				},
																			}))
																		}
																	/>
																</span>
															</span>
														);
													}
												)}
											</div>
										</div>
									</div>
								);
							}
						)}
					</div>
				)}
				{showTestPanel && count > 18 && count < 22 && false && (
					<div className="multi-sprakforstaelse multi-sprakforstaelse__tutorial">
						{this.multiplePickAssignment[counter].map(
							(assignment) => {
								const {id, choices} = assignment;
								const assignmentAudioPlayCount =
									audioPlayCounts[id] || 0;
								const isAudioDisabled =
									assignmentAudioPlayCount ===
									maxAudioPlayCount;
								return (
									<div
										className="multi-words-wrapper"
										key={id}
									>
										<div className="multi-single-word">
											<p className="instruction">
												<AudioPlayer
													inline
													autoplay
													refs={this.audioRefs}
													src={assignment.mainSound}
													disabled={isAudioDisabled}
													onComplete={() => {
														this.toggleTimeout(
															'audioAction'
														);
														this.setState({
															showChoices: true,
														});
													}}
													onPause={() => {
														this.toggleTimeout(
															'audioAction'
														);
													}}
													onStart={() => {
														this.setState({
															audioPlayCounts:
																updateObject(
																	audioPlayCounts,
																	{
																		[id]:
																			assignmentAudioPlayCount +
																			1,
																	}
																),
														});
													}}
												/>
												{id} von 21
											</p>
										</div>
										{showChoices && (
											<div className="multi-words">
												<div className="multi-word-list">
													{choices.map(
														(choice, i) => {
															const selectedIndices =
																multiSelectedChoice?.[
																	id
																] || [];
															const selected =
																selectedIndices.includes(
																	i
																);
															const selectionNumber =
																selected
																	? selectedIndices.indexOf(
																			i
																	  ) + 1
																	: null;

															return (
																<span
																	className={`multi-word ${
																		selected
																			? 'selected'
																			: ''
																	}`}
																	key={i}
																	onClick={() => {
																		this.handleMultiSelect(
																			id,
																			i
																		);
																	}}
																>
																	<div className="multi-img-wrapper">
																		<img
																			className={`multi-imgItem ${
																				selected
																					? 'selected'
																					: ''
																			}`}
																			src={
																				choice.img
																			}
																			alt={
																				choice.word
																			}
																		/>
																		{selected && (
																			<span className="selection-circle">
																				{
																					selectionNumber
																				}
																			</span>
																		)}
																	</div>
																</span>
															);
														}
													)}
												</div>
											</div>
										)}
									</div>
								);
							}
						)}
					</div>
				)}
				{/* Off-screen preloader: fetch next 2 assignments' images in background */}
				{showTestPanel && count < 18 && (
					<div className="sf-preloader" aria-hidden="true">
						{[counter + 1, counter + 2].flatMap((nextCounter) => {
							const nextAssignment = this.singlePickAssignment[nextCounter];
							if (!nextAssignment) return [];
							return nextAssignment.flatMap((assignment) =>
								assignment.choices.map((choice, i) => (
									<img
										key={`preload-${assignment.id}-${i}`}
										src={choice.img}
										alt=""
										loading="eager"
										onLoad={() =>
											this.setState((prev) => ({
												imageLoaded: {
													...prev.imageLoaded,
													[`${assignment.id}-${i}`]: true,
												},
											}))
										}
									/>
								))
							);
						})}
					</div>
				)}

				{nextQuestion && count < 19 && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							this.setState({
								showTestPanel: true,
								nextQuestion: false,
								showChoices: false,
							});
						}}
						disabled={isSendingTestResults}
					>
						{'Weiter'}
					</button>
				)}
				{isDoneButtonVisible && (
					<button
						className="lit-btn bg-primary"
						onClick={() => onNextStep(results)}
					>
						{strings.done}
					</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Test);
